import moment from 'moment'

export const getExcelName = (dataType : string)=>{
   const formattedDate = moment().format('YYYY-MM-DD_HH-mm-ss');
   return `${formattedDate}-${dataType}.xlsx`
}

export const formatDateTime =  (date: string)=>{
   return moment(date).format('YYYY-MM-DD HH:mm:ss');
}